import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-reglement-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4 mb-3" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "col-md-4 mb-3" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = {
  key: 0,
  class: "col-md-4 mb-3"
}
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = {
  key: 1,
  class: "col-md-4 mb-3"
}
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 2,
  class: "col-md-4 mb-3"
}
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 3,
  class: "col-md-4 mb-3"
}
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = {
  key: 4,
  class: "col-md-4 mb-3"
}
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = { class: "tooltip-wrapper" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "tooltip-box"
}
const _hoisted_23 = { class: "mb-0 mt-1" }
const _hoisted_24 = { class: "col-md-4 mb-3" }
const _hoisted_25 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_26 = {
  key: 5,
  class: "col-md-4 mb-3"
}
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_28 = { class: "col-md-4 mb-3" }
const _hoisted_29 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_30 = { class: "col-md-4 mb-3" }
const _hoisted_31 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_32 = {
  key: 6,
  class: "col-md-4 mb-3"
}
const _hoisted_33 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_34 = {
  key: 7,
  class: "col-md-4 mb-3"
}
const _hoisted_35 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_36 = {
  key: 8,
  class: "col-md-4 mb-3"
}
const _hoisted_37 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_38 = {
  key: 9,
  class: "col-md-4 mb-3"
}
const _hoisted_39 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_40 = {
  key: 10,
  class: "col-md-4 mb-3"
}
const _hoisted_41 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_42 = {
  key: 11,
  class: "col-md-4 mb-3"
}
const _hoisted_43 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_44 = {
  key: 12,
  class: "col-md-12"
}
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-md-6 mb-md-12" }
const _hoisted_47 = { class: "border border-primary mb-5" }
const _hoisted_48 = {
  class: "row fw-bold py-2",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_49 = { class: "col-md-5" }
const _hoisted_50 = {
  key: 0,
  class: "fs-5 text-white",
  style: {"text-align":"end","font-weight":"bold"}
}
const _hoisted_51 = { class: "px-3" }
const _hoisted_52 = { class: "row align-items-center" }
const _hoisted_53 = { class: "col-md-4 px-1" }
const _hoisted_54 = ["onUpdate:modelValue"]
const _hoisted_55 = { class: "col-md-4 px-1" }
const _hoisted_56 = { class: "col-md-4 px-1" }
const _hoisted_57 = ["onUpdate:modelValue"]
const _hoisted_58 = { class: "col-md-6 mb-md-12" }
const _hoisted_59 = { class: "col-md-7" }
const _hoisted_60 = { class: "h3 fs-4 text-white" }
const _hoisted_61 = { class: "col-md-5" }
const _hoisted_62 = {
  class: "fs-5 text-white",
  style: {"text-align":"end","font-weight":"bold"}
}
const _hoisted_63 = {
  key: 0,
  class: "px-3"
}
const _hoisted_64 = { class: "row align-items-center" }
const _hoisted_65 = { class: "col-md-4 px-1" }
const _hoisted_66 = ["onUpdate:modelValue"]
const _hoisted_67 = { class: "col-md-4 px-1" }
const _hoisted_68 = { class: "col-md-4 px-1" }
const _hoisted_69 = ["onUpdate:modelValue"]
const _hoisted_70 = {
  key: 0,
  class: "text-danger mt-2"
}
const _hoisted_71 = {
  key: 1,
  class: "px-3 py-4 text-center"
}
const _hoisted_72 = { class: "mb-0 text-muted" }
const _hoisted_73 = { class: "text-warning" }
const _hoisted_74 = { class: "row mt-3" }
const _hoisted_75 = { class: "col-md-2" }
const _hoisted_76 = { class: "form-group mb-2" }
const _hoisted_77 = {
  key: 0,
  class: "text-black mt-2"
}
const _hoisted_78 = {
  key: 13,
  class: "col-md-12"
}
const _hoisted_79 = { class: "table table-bordered table-striped" }
const _hoisted_80 = { class: "col-md-12 mt-3" }
const _hoisted_81 = { class: "d-flex align-items-center" }
const _hoisted_82 = {
  ref: "submitButton",
  class: "btn btn-primary me-3",
  type: "submit"
}
const _hoisted_83 = {
  key: 1,
  class: "text-center py-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_format_montant = _resolveDirective("format-montant")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[46] || (_cache[46] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold" }, "Enregistrer un règlement")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isFormReady)
        ? (_openBlock(), _createBlock(_component_Form, {
            key: 0,
            ref: "reglementForm",
            onSubmit: _ctx.addReglement,
            "validation-schema": _ctx.reglementSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Date du règlement "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "date",
                      type: "datetime-local",
                      value: _ctx.getCurrentDateTime(),
                      readonly: "",
                      class: "form-control shadow-none fs-md-15 text-black"
                    }, null, 8, ["value"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "date",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black mb-10" }, [
                      _createTextVNode(" Type de règlement "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "typeReglement",
                      modelValue: _ctx.typeReglement,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.typeReglement) = $event)),
                      type: "text"
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          options: ['Commande', 'Créance'],
                          "preserve-search": true,
                          multiple: false,
                          searchable: true,
                          placeholder: "Sélectionner le type de reglement",
                          label: "label",
                          "track-by": "label",
                          onSelect: _ctx.onTypeReglementSelect
                        }), null, 16, ["modelValue", "onUpdate:modelValue", "onSelect"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "typeReglement",
                      class: "text-danger"
                    })
                  ])
                ]),
                (_ctx.selectedTypeReglement === 'Créance')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black mb-10" }, [
                          _createTextVNode(" Créance "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "creance",
                          modelValue: _ctx.creance,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.creance) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, {
                              options: _ctx.creanceOptions,
                              "preserve-search": true,
                              multiple: false,
                              searchable: true,
                              placeholder: "Sélectionner une créance",
                              label: "label",
                              "track-by": "label",
                              onSelect: _ctx.onCreanceSelect
                            }), null, 16, ["modelValue", "onUpdate:modelValue", "options", "onSelect"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "creance",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedTypeReglement === 'Créance')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Montant Créance", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          value: _ctx.montantCreance || 0,
                          readonly: "",
                          class: "form-control shadow-none fs-md-15 text-black"
                        }, null, 8, _hoisted_12), [
                          [_directive_format_montant]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedTypeReglement === 'Créance')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Reste à payer (Créance)", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          value: _ctx.calculatedResteAPayer,
                          readonly: "",
                          class: "form-control shadow-none fs-md-15 text-black"
                        }, null, 8, _hoisted_15), [
                          [_directive_format_montant]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedTypeReglement === 'Commande')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Commandes non payées "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, { name: "commande" }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              options: _ctx.commandesOptions,
                              searchable: true,
                              "track-by": "value",
                              label: "label",
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, {
                              placeholder: "Sélectionner la commande",
                              onChange: _ctx.handleCommandeChange,
                              disabled: !_ctx.caisseActive
                            }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "onChange", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "commande",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedTypeReglement === 'Commande')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _cache[20] || (_cache[20] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Montant TTC "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_Field, { name: "montantTtc" }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.montantTtc) = $event)),
                                class: "form-control shadow-none fs-md-15 text-black",
                                placeholder: "Entrer le montant",
                                readonly: "",
                                disabled: _ctx.selectedModeReglementLabel?.toUpperCase() === 'ESPECES' && !_ctx.caisseActive
                              }, null, 8, _hoisted_21), [
                                [_vModelText, _ctx.montantTtc]
                              ])
                            ]),
                            _: 1
                          }),
                          (_ctx.commandeSelectionnee)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _cache[19] || (_cache[19] = _createElementVNode("strong", null, "Récapitulatif :", -1)),
                                _createElementVNode("ul", _hoisted_23, [
                                  _createElementVNode("li", null, "Montant total : " + _toDisplayString(_ctx.commandeSelectionnee.montTTC) + " Fcfa", 1),
                                  _createElementVNode("li", null, "Déjà payé : " + _toDisplayString(_ctx.commandeSelectionnee.montantDejaPaye) + " Fcfa", 1),
                                  _createElementVNode("li", null, "Restant : " + _toDisplayString(_ctx.commandeSelectionnee.montantRest) + " Fcfa", 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Montant payé "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "montantPaye" }, {
                      default: _withCtx(({ field }) => [
                        _withDirectives(_createElementVNode("input", _mergeProps({ type: "text" }, field, {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.montantPaye) = $event)),
                          class: "form-control shadow-none fs-md-15 text-black",
                          name: "montantPaye"
                        }), null, 16), [
                          [_directive_format_montant],
                          [_vModelText, _ctx.montantPaye]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "montantPaye",
                      class: "text-danger"
                    })
                  ])
                ]),
                (_ctx.selectedTypeReglement === 'Commande')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Montant Reste à Payer", -1)),
                        _createVNode(_component_Field, { name: "montantRest" }, {
                          default: _withCtx(({ field }) => [
                            _createElementVNode("input", _mergeProps({ type: "number" }, field, {
                              readonly: "",
                              class: "form-control shadow-none fs-md-15 text-black"
                            }), null, 16)
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-block text-black mb-10" }, [
                      _createTextVNode(" Mode de règlement "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "modeReglement",
                      modelValue: _ctx.modeReglement,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modeReglement) = $event)),
                      type: "text"
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          options: _ctx.modeReglementOptions,
                          "preserve-search": true,
                          multiple: false,
                          searchable: true,
                          placeholder: "Sélectionner un mode de règlement",
                          label: "label",
                          "track-by": "label",
                          onSelect: _ctx.onModeReglementSelect
                        }), null, 16, ["modelValue", "onUpdate:modelValue", "options", "onSelect"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "modeReglement",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _cache[24] || (_cache[24] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Référence Document "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "refDocument" }, {
                      default: _withCtx(({ field }) => [
                        _withDirectives(_createElementVNode("input", _mergeProps({ type: "text" }, field, {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.refDocument) = $event)),
                          class: "form-control shadow-none fs-md-15 text-black",
                          name: "refDocument"
                        }), null, 16), [
                          [_vModelText, _ctx.refDocument]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "refDocument",
                      class: "text-danger"
                    })
                  ])
                ]),
                (_ctx.showCompteField)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _cache[25] || (_cache[25] = _createElementVNode("label", { class: "d-block text-black mb-10" }, [
                          _createTextVNode("Compte "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "compte",
                          modelValue: _ctx.compte,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.compte) = $event)),
                          type: "text"
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, {
                              options: _ctx.compteOptions,
                              "preserve-search": true,
                              multiple: false,
                              searchable: true,
                              placeholder: "Sélectionner un compte",
                              label: "label",
                              "track-by": "label"
                            }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "compte",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showRefTransactionField)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _cache[26] || (_cache[26] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Référence de transaction "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "refTransaction",
                          modelValue: _ctx.refTransaction,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.refTransaction) = $event)),
                          class: "form-control shadow-none fs-md-15 text-black"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "refTransaction",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showBanqueField)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _cache[27] || (_cache[27] = _createElementVNode("label", { class: "d-block text-black mb-10" }, [
                          _createTextVNode("Banque "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "banque",
                          modelValue: _ctx.banque,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.banque) = $event)),
                          type: "text"
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, {
                              options: _ctx.banqueOptions,
                              "preserve-search": true,
                              multiple: false,
                              searchable: true,
                              placeholder: "Sélectionner une banque",
                              label: "label",
                              "track-by": "label"
                            }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "banque",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showNumCompteField)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _cache[28] || (_cache[28] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Numéro de chèque "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "numeroCheque",
                          modelValue: _ctx.numeroCheque,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.numeroCheque) = $event)),
                          class: "form-control shadow-none fs-md-15 text-black"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "numeroCheque",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showDateChequeField)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _cache[29] || (_cache[29] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Date d'émission du chèque "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "dateCheque",
                          type: "datetime-local",
                          value: _ctx.getCurrentDateTime(),
                          class: "form-control shadow-none fs-md-15 text-black"
                        }, null, 8, ["value"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "dateCheque",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showDateVirementField)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _cache[30] || (_cache[30] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Date du virement "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "dateVirement",
                          type: "datetime-local",
                          value: _ctx.getCurrentDateTime(),
                          class: "form-control shadow-none fs-md-15 text-black"
                        }, null, 8, ["value"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "dateVirement",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedModeReglementLabel?.toUpperCase() === 'ESPECES' && _ctx.selectedTypeReglement === 'Commande' && _ctx.caisseActive)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                              _cache[31] || (_cache[31] = _createElementVNode("div", { class: "col-md-7" }, [
                                _createElementVNode("h3", { class: "h3 fs-4 text-white" }, "Billetage Paiement")
                              ], -1)),
                              _createElementVNode("div", _hoisted_49, [
                                (_ctx.montantTotalEncaissement)
                                  ? (_openBlock(), _createElementBlock("h3", _hoisted_50, _toDisplayString(_ctx.montantTotalEncaissement) + " Fcfa", 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              _cache[32] || (_cache[32] = _createElementVNode("div", { class: "row mt-2" }, [
                                _createElementVNode("div", { class: "col-md-4" }, [
                                  _createElementVNode("label", { class: "fw-semibold" }, "Monnaie")
                                ]),
                                _createElementVNode("div", { class: "col-md-4" }, [
                                  _createElementVNode("label", { class: "fw-semibold" }, "Quantité")
                                ]),
                                _createElementVNode("div", { class: "col-md-4" }, [
                                  _createElementVNode("label", { class: "fw-semibold" }, "Montant")
                                ])
                              ], -1)),
                              _cache[33] || (_cache[33] = _createElementVNode("hr", { class: "mt-0" }, null, -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billetageList, (billetage, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "container-tight m-0 py-1"
                                }, [
                                  _createElementVNode("div", _hoisted_52, [
                                    _createElementVNode("div", _hoisted_53, [
                                      _withDirectives(_createElementVNode("input", {
                                        name: "monnaie",
                                        "onUpdate:modelValue": ($event: any) => ((billetage.libelle) = $event),
                                        readonly: "",
                                        class: "form-control compact-input",
                                        placeholder: "Monnaie"
                                      }, null, 8, _hoisted_54), [
                                        [_vModelText, billetage.libelle]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_55, [
                                      _createVNode(_component_Field, {
                                        name: `billetageList[${index}].qteBillet`,
                                        type: "number",
                                        min: "0",
                                        modelValue: billetage.qteBillet,
                                        "onUpdate:modelValue": ($event: any) => ((billetage.qteBillet) = $event),
                                        onInput: event => _ctx.handleBilletageInput(event, billetage, 'encaissement'),
                                        onKeypress: _cache[10] || (_cache[10] = ($event: any) => (_ctx.restrictInput($event))),
                                        class: "form-control compact-input",
                                        placeholder: "Qté",
                                        disabled: !_ctx.caisseActive
                                      }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "onInput", "disabled"]),
                                      _createVNode(_component_ErrorMessage, {
                                        name: `billetageList[${index}].qteBillet`,
                                        class: "text-danger compact-error"
                                      }, null, 8, ["name"])
                                    ]),
                                    _createElementVNode("div", _hoisted_56, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": ($event: any) => ((billetage.montant) = $event),
                                        readonly: "",
                                        placeholder: "Montant",
                                        class: "form-control compact-input"
                                      }, null, 8, _hoisted_57), [
                                        [_vModelText, billetage.montant]
                                      ])
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["border mb-5", _ctx.montantManquant > 0 ? 'border-indigo-500 bg-indigo-50' : 'border-danger'])
                          }, [
                            _createElementVNode("div", {
                              class: "row fw-bold py-2",
                              style: _normalizeStyle(_ctx.montantManquant > 0 ? 'background-color: #6366f1; color: white' : 'background-color: #a40a0a')
                            }, [
                              _createElementVNode("div", _hoisted_59, [
                                _createElementVNode("h3", _hoisted_60, _toDisplayString(_ctx.montantManquant > 0 ? 'Montant Manquant' : 'Reliquat à Rendre'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_61, [
                                _createElementVNode("h3", _hoisted_62, _toDisplayString(_ctx.montantManquant > 0 ? _ctx.montantManquant : _ctx.reliquatCalcule) + " Fcfa ", 1)
                              ])
                            ], 4),
                            (_ctx.montantManquant === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                  _cache[34] || (_cache[34] = _createElementVNode("div", { class: "row mt-2" }, [
                                    _createElementVNode("div", { class: "col-md-4" }, [
                                      _createElementVNode("label", { class: "fw-semibold" }, "Monnaie")
                                    ]),
                                    _createElementVNode("div", { class: "col-md-4" }, [
                                      _createElementVNode("label", { class: "fw-semibold" }, "Quantité")
                                    ]),
                                    _createElementVNode("div", { class: "col-md-4" }, [
                                      _createElementVNode("label", { class: "fw-semibold" }, "Montant")
                                    ])
                                  ], -1)),
                                  _cache[35] || (_cache[35] = _createElementVNode("hr", { class: "mt-0" }, null, -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billetageSortieList, (billetage, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: index,
                                      class: "container-tight m-0 py-1"
                                    }, [
                                      _createElementVNode("div", _hoisted_64, [
                                        _createElementVNode("div", _hoisted_65, [
                                          _withDirectives(_createElementVNode("input", {
                                            name: "monnaie",
                                            "onUpdate:modelValue": ($event: any) => ((billetage.libelle) = $event),
                                            readonly: "",
                                            class: "form-control compact-input",
                                            placeholder: "Monnaie"
                                          }, null, 8, _hoisted_66), [
                                            [_vModelText, billetage.libelle]
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_67, [
                                          _createVNode(_component_Field, {
                                            name: `billetageSortieList[${index}].qteBillet`,
                                            type: "number",
                                            min: "0",
                                            modelValue: billetage.qteBillet,
                                            "onUpdate:modelValue": ($event: any) => ((billetage.qteBillet) = $event),
                                            onInput: event => _ctx.handleBilletageInput(event, billetage, 'sortie'),
                                            onBlur: () => { if (!billetage.qteBillet) billetage.qteBillet = 0 },
                                            onKeypress: _cache[11] || (_cache[11] = ($event: any) => (_ctx.restrictInput($event))),
                                            class: "form-control compact-input",
                                            placeholder: "Qté",
                                            disabled: !_ctx.caisseActive
                                          }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "onInput", "onBlur", "disabled"]),
                                          _createVNode(_component_ErrorMessage, {
                                            name: `billetageSortieList[${index}].qteBillet`,
                                            class: "text-danger compact-error"
                                          }, null, 8, ["name"])
                                        ]),
                                        _createElementVNode("div", _hoisted_68, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": ($event: any) => ((billetage.montant) = $event),
                                            readonly: "",
                                            placeholder: "Montant",
                                            class: "form-control compact-input"
                                          }, null, 8, _hoisted_69), [
                                            [_vModelText, billetage.montant]
                                          ])
                                        ])
                                      ])
                                    ]))
                                  }), 128)),
                                  (_ctx.montantTotalSortie > _ctx.reliquatCalcule)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, " Le billetage de sortie (" + _toDisplayString(_ctx.montantTotalSortie) + " Fcfa) dépasse le reliquat (" + _toDisplayString(_ctx.reliquatCalcule) + " Fcfa). ", 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                  _cache[37] || (_cache[37] = _createElementVNode("i", { class: "fa fa-exclamation-triangle fa-3x text-warning mb-3" }, null, -1)),
                                  _cache[38] || (_cache[38] = _createElementVNode("p", { class: "mb-2 text-dark fw-bold" }, "Paiement Partiel", -1)),
                                  _createElementVNode("p", _hoisted_72, [
                                    _cache[36] || (_cache[36] = _createTextVNode(" Il manque encore ")),
                                    _createElementVNode("strong", _hoisted_73, _toDisplayString(_ctx.montantManquant) + " Fcfa", 1)
                                  ]),
                                  _cache[39] || (_cache[39] = _createElementVNode("p", { class: "mb-0 text-muted small mt-2" }, "Le client pourra compléter le paiement plus tard", -1))
                                ]))
                          ], 2)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _cache[41] || (_cache[41] = _createElementVNode("div", { class: "col-md-10" }, null, -1)),
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _cache[40] || (_cache[40] = _createElementVNode("label", { class: "form-label fw-semibold mb-1 text-start d-block" }, "Reliquat à retourner", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: _normalizeClass(["form-control form-control-sm shadow-none text-start", { 'is-warning': _ctx.reliquatRetourner > 0 }]),
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.reliquatRetourner) = $event)),
                              readonly: ""
                            }, null, 2), [
                              [
                                _vModelText,
                                _ctx.reliquatRetourner,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            (_ctx.reliquatRetourner > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_77, " Reliquat non rendu : " + _toDisplayString(_ctx.reliquatRetourner) + " Fcfa. ", 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.creanceValue?.echeances?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                      _cache[43] || (_cache[43] = _createElementVNode("h5", { class: "mt-3" }, "Échéances", -1)),
                      _createElementVNode("table", _hoisted_79, [
                        _cache[42] || (_cache[42] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Date Échéance"),
                            _createElementVNode("th", null, "Montant"),
                            _createElementVNode("th", null, "Reste à payer"),
                            _createElementVNode("th", null, "Statut")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creanceValue.echeances, (echeance, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", null, _toDisplayString(_ctx.format_Date(echeance.date)), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.separateur(echeance.montant)), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.separateur(echeance.reste_a_payer)), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(['badge', _ctx.getStatutBadge(echeance).class])
                                }, _toDisplayString(_ctx.getStatutBadge(echeance).text), 3)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("button", _hoisted_82, " Enregistrer le règlement ", 512),
                    _createVNode(_component_router_link, {
                      to: "/reglements/liste-reglements",
                      class: "btn btn-danger"
                    }, {
                      default: _withCtx(() => _cache[44] || (_cache[44] = [
                        _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                        _createElementVNode("span", { class: "position-relative" }, null, -1),
                        _createTextVNode("Annuler ")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_83, _cache[45] || (_cache[45] = [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin fa-2x" }, null, -1)
          ])))
    ])
  ]))
}